import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "business-card__body" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, { class: "brg-card-outlined business-card" }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "business-card__title" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_divider),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(_toDisplayString('상호명'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.validatedBusinessName), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(_toDisplayString('대표자명'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.validatedCeoName), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode(_toDisplayString('사업자 등록번호'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [2]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.validatedBusinessNumber), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode(_toDisplayString('사업장 주소'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [3]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.businessInfoAddress), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode(_toDisplayString('업태'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [4]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.validatedBusinessCondition), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode(_toDisplayString('종목'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [5]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.validatedBusinessType), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mt-4 business-card__item"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "py-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                        _createTextVNode(_toDisplayString('이메일'))
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [6]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.validatedCeoEmail), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
